export default "__VITE_ASSET__Djdccxcm__"